import { render, staticRenderFns } from "./appFooter.vue?vue&type=template&id=6fcbf27f&scoped=true"
import script from "./appFooter.vue?vue&type=script&lang=js"
export * from "./appFooter.vue?vue&type=script&lang=js"
import style0 from "./appFooter.vue?vue&type=style&index=0&id=6fcbf27f&prod&lang=scss&scoped=true"
import style1 from "./appFooter.vue?vue&type=style&index=1&id=6fcbf27f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcbf27f",
  null
  
)

export default component.exports